import styles from './ParagraphText.css'
import _ from 'lodash'
import PropTypes from 'prop-types'

const getContent = props => {
  let contentFromProps = props.content || _.get(props, 'input.value', '')

  if (_.isArray(contentFromProps)) {
    contentFromProps = contentFromProps[0]
  }

  return contentFromProps || '--'
}

const ParagraphText = (props) => {
  const content = getContent(props)
  return (
    <p
      data-role='paragraph-text'
      className={styles.ParagraphText}
    >
      {content}
    </p>
  )
}

ParagraphText.propTypes = {
  content: PropTypes.string,
  input: PropTypes.object
}

export default ParagraphText
